import React, { useState } from "react";
import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import { useForm } from "react-hook-form";
import CardSection from "../CardSection/CardSection";
import Loader from "../loader";
import { toast } from "react-toastify";

const CheckoutForm = () => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    if (!stripe || !elements) return;

    setLoading(true);
    const card = elements.getElement(CardElement);
    const { token, error } = await stripe.createToken(card);

    if (error) {
      setLoading(false);
      toast.error("Payment Failed");
    } else {
      const paymentData = {
        token: token.id,
        planId: "67a48abe049311f24ff2b2cc",
        cardholderName: data.cardholderName,
        country: data.country,
        zipCode: data.zipCode,
        email: data.email,
      };

      const response = await fetch("/api/subscription", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(paymentData),
      });

      const result = await response.json();
      setLoading(false);
      if (response.ok) {
        toast.success("Payment Successful");
      } else {
        toast.error("Payment Failed");
      }
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-8">
      <label className="block text-[#737373] text-[1.6rem]">Email</label>
      <input
        type="email"
        {...register("email", { required: "Email is required", pattern: { value: /^\S+@\S+$/i, message: "Invalid email format" } })}
        className="w-full p-3 border bg-[#F2F2F282] focus:outline-none rounded-md text-[1.4rem]"
        placeholder="Email"
      />
      {errors.email && <p className="text-red-500">{errors.email.message}</p>}

      <CardSection />

      <label className="block text-[#737373] mt-4 text-[1.6rem]">Cardholder Name</label>
      <input
        type="text"
        {...register("cardholderName", { required: "Cardholder name is required" })}
        className="w-full p-3 border bg-[#F2F2F282] focus:outline-none rounded-md text-[1.4rem]"
        placeholder="Full name on card"
      />
      {errors.cardholderName && <p className="text-red-500">{errors.cardholderName.message}</p>}
      <label className="block text-[#737373] mt-4 text-[1.6rem]">Country or Region</label>
      <select
        {...register("country", { required: "Country is required" })}
        className="w-full p-3 border rounded-md text-[#737373] bg-[#F2F2F282] text-[1.4rem] focus:outline-none"
      >
        <option value="">Select Country</option>
        <option value="United States">United States</option>
      </select>
      {errors.country && <p className="text-red-500">{errors.country.message}</p>}
      <input
        type="number"
        {...register("zipCode", { required: "ZIP Code is required", pattern: { value: /^[0-9]{5}$/, message: "Invalid ZIP Code" } })}
        className="w-full p-3 border rounded-md mt-2 text-[1.4rem] bg-[#F2F2F282] focus:outline-none"
        placeholder="ZIP"
      />
      {errors.zipCode && <p className="text-red-500">{errors.zipCode.message}</p>}

      <button
        type="submit"
        disabled={!stripe || loading}
        className="w-full bg-[#173363] text-white py-3 rounded-lg mt-4 text-[1.6rem]"
      >
        {loading ? <Loader /> : "Pay"}
      </button>

      <p className="text-center text-[#525252] mt-2 text-[1.4rem]">
        By clicking Pay, you agree to the Link Terms and Privacy Policy.
      </p>
    </form>
  );
};

export default CheckoutForm;
























